import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-commission-signalman',
  templateUrl: './dialog-commission-signalman.component.html',
  styleUrls: ['./dialog-commission-signalman.component.scss'],
})
export class DialogCommissionSignalmanComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
